<template>
  <section class="default-container">
    <BreadCrumb :bread-crumb="breadCrumb" />
    <div class="content">
      <div class="content-left">
        <div class="left-title">공개강좌</div>
        <div class="menu-wrap">
          <div v-for="(menu, index) in menuList" :key="'menu' + index" class="menu-item">
            <div :class="['menu-name', {on: menu.selected}]" @click="menuClick(index)">{{ menu.name }}</div>
            <div v-show="menu.subMenuShow" class="sub-menu__wrap">
              <div
                v-for="(subMenu, idx) in menu.subMenu"
                :key="'subMenu' + idx"
                :class="['sub-menu__item', {on: subMenu.selected}]"
                @click="subMenuClick(index, idx)"
              >
                ・ {{ subMenu.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <Tab1 v-if="menuList[0].selected === true" :menu="menuList[0].subMenu.findIndex(item => item.selected)" />
        <Tab2 v-if="menuList[1].selected === true" :menu="menuList[1].subMenu.findIndex(item => item.selected)" />
        <Tab3 v-if="menuList[2].selected === true" :menu="menuList[2].subMenu.findIndex(item => item.selected)" />
        <Tab4 v-if="menuList[3].selected === true" :menu="menuList[3].subMenu.findIndex(item => item.selected)" />
      </div>
    </div>
  </section>
</template>

<script>
import {useMemberStore} from '~/store/member/index.js'
import BreadCrumb from '~/components/common/BreadCrumb.vue'
import Tab1 from '~/components/seminar/Tab1.vue'
import Tab2 from '~/components/seminar/Tab2.vue'
import Tab3 from '~/components/seminar/Tab3.vue'
import Tab4 from '~/components/seminar/Tab4.vue'
import {useHead} from '#imports'

export default {
  name: 'SeminarIndex',
  components: {BreadCrumb, Tab1, Tab2, Tab3, Tab4},
  setup() {
    const memberStore = useMemberStore()
    // 사이트 링크용 메타 태그 설정
    useHead({
      title: '공개강좌 | 한국인사관리협회',
      meta: [
        {
          name: 'description',
          content: 'HR 및 인사관리 분야의 최신 트렌드를 배울 수 있는 한국인사관리협회의 다양한 공개강좌 및 세미나 정보를 확인하세요.'
        },
        {
          property: 'og:title', // Open Graph 태그 (카카오톡, 페이스북 등 공유 시 미리보기 제목)
          content: '공개강좌 | 한국인사관리협회'
        },
        {
          property: 'og:description', // Open Graph 태그 (공유 시 미리보기 설명)
          content: 'HR 및 인사관리 분야의 최신 트렌드를 배울 수 있는 한국인사관리협회의 다양한 공개강좌 및 세미나 정보를 확인하세요.'
        }
      ],
      // 쿼리 파라미터가 붙더라도 항상 이 URL이 표준임을 알립니다.
      link: [
        { rel: 'canonical', href: 'https://insabank.com/seminar' }
      ]
    })
    return {memberStore}
  },
  computed: {
    isAuthenticated() {
      return this.store.isAuthenticated
    }
  },
  data() {
    return {
      isAuth: false,
      breadCrumb: [],
      menuList: [
        {
          name: '교육과정',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '월간교육일정표', selected: false},
            {name: '연간교육일정표', selected: false}
          ]
        },
        {
          name: '접수중 교육과정',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '교육참가 신청', selected: false},
            {name: '종료된 교육과정', selected: false},
            {name: '수강내역 및 수료증 출력', selected: false}
          ]
        },
        {
          name: '교육장 안내',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '교육장 안내', selected: false}]
        },
        {
          name: '교육신청 방법',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '교육신청 방법', selected: false},
            {name: '교육안내문 신청', selected: false}
          ]
        }
      ]
    }
  },
  watch: {
    $route: {
      handler: function () {
        this.menuController()
      },
      deep: true
    }
  },
  mounted() {
    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/fullcalendar@6.1.15/index.global.min.js'
    script.async = true
    document.head.appendChild(script)

    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = 'https://cdn.jsdelivr.net/npm/fullcalendar@6.1.15/main.min.css'
    document.head.appendChild(link)
    this.isAuth = this.memberStore.isAuthenticated
    this.menuController()
  },
  methods: {
    menuController() {
      const urlParams = new URLSearchParams(window.location.search)
      const menuIndex = parseInt(urlParams.get('menu') || '0')
      const subMenuIndex = parseInt(urlParams.get('subMenu') || '0')
      const calendarDate = urlParams.get('calendarDate')

      // 기존 메뉴 서브메뉴는 초기화
      this.menuList.forEach(menu => {
        menu.selected = false
        menu.subMenuShow = false
        if (menu.subMenu) {
          menu.subMenu.forEach(subMenu => {
            subMenu.selected = false
          })
        }
      })

      // 선택된 메뉴와 서브메뉴의 상태 변경
      if (this.menuList[menuIndex]) {
        this.menuList[menuIndex].selected = true
        this.menuList[menuIndex].subMenuShow = true

        if (this.menuList[menuIndex].subMenu[subMenuIndex]) {
          this.menuList[menuIndex].subMenu[subMenuIndex].selected = true
        }
      }

      // 메뉴와 서브메뉴가 모두 0 이라면 type을 쿼리에 붙여준다
      if (menuIndex === 0 && subMenuIndex === 0) {
        // calendarDate가 있으면 calendarDate도 붙여준다
        if (calendarDate) {
          this.$router.push(`/seminar?menu=0&subMenu=0&type=&calendarDate=${calendarDate}`)
        } else {
          this.$router.push(`/seminar?menu=0&subMenu=0&type=`)
        }
      }
      this.breadCrumbController(this.menuList[menuIndex].subMenu)
    },
    breadCrumbController(item) {
      // 초기화
      this.breadCrumb = []
      // 기본 breadcrumb 설정
      this.breadCrumb = ['홈', '공개강좌']
      this.menuList.forEach(menu => {
        if (menu.selected) {
          this.breadCrumb.push(menu.name)
          if (menu.subMenu) {
            menu.subMenu.forEach(subMenu => {
              if (subMenu.selected) {
                this.breadCrumb.push(subMenu.name)
              }
            })
          }
        }
      })
    },
    menuClick(index) {
      switch (index) {
        case 0:
          this.$router.push('/seminar?menu=0&subMenu=0&type=')
          break
        case 1:
          this.$router.push('/seminar?menu=1&subMenu=0&type=&keyword=&page=1')
          break
        case 2:
          this.$router.push('/seminar?menu=2&subMenu=0')

          break
        case 3:
          this.$router.push('/seminar?menu=3&subMenu=0')
          break
      }

      window.scrollTo({top: 0})
    },
    subMenuClick(index, idx) {
      if (
        index === 3 && idx === 1 ||
        index === 1 && idx === 2
      ) {
        if (!this.isAuth) {
          alert('로그인 후 이용 가능합니다.')
          return
        }
      }
      this.$router.push(`/seminar?menu=${index}&subMenu=${idx}`)
      window.scrollTo({top: 0})
    }
  }
}
</script>

<style scoped lang="scss">
.default-container {
  padding: 48px 0 100px;
  .content {
    display: flex;
    gap: 24px;
    position: relative;
    .content-left {
      min-width: 222px;
      min-width: 222px;
      position: sticky;
      top: 40px;
      left: 0;
      height: 600px;
      .left-title {
        color: #121212;
        font-family: 'Godo', sans-serif;
        border-bottom: 1px solid #121212;
        padding-bottom: 24px;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%; /* 30px */
      }
      .menu-name {
        padding: 24px;
        border-bottom: 1px solid #dbdbdb;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 20px */
        cursor: pointer;
        &:hover {
          color: #0058aa;
        }
        &.on {
          font-weight: 700;
          color: #0058aa;
        }
      }
      .sub-menu__item {
        padding: 12px 24px;
        cursor: pointer;
        color: #606060;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 17.5px */
        &.on {
          font-weight: 700;
          color: #0058aa;
        }
        &:hover {
          background: #f8fbfd;
          color: #0058aa;
        }
        &:last-child {
          border-bottom: 1px solid #dbdbdb;
        }
      }
    }
    .content-right {
      width: 100%;
    }
  }
}
</style>
